const { mounterCbsData, mounterIbsData, getIbsCbsIndicators } = require('./IbsCbsCalculationService');

let productsNFeInitial = {
  itemProduct: "",
  codeProduct: "",
  eanProduct: "",
  descriptionProduct: "",
  ncmProduct: "",
  nomenclatureValueCustomsProduct: "",
  codeCstProdut: "",
  relevantScaleIndicatorProduct: "",
  codeManufacturerProduct: "",
  recipientProduct: "",
  extIpiProduct: "",
  cfopProduct: "",
  unitBusinessProduct: "",
  amountBusinessProduct: "",
  valueUnityBusinessProduct: "",
  valueTotalGrossProduct: "",
  valueCostOfFreight: "",
  unityTaxProduct: "",
  amountTaxProduct: "",
  valueUnityTaxProduct: "",
  indicatesWhetherProduct: "",
  valueInsurancePriceProduct: "",
  sourceMerchandise: "",
  cstProduct: "",
  valueOfApproximateTax: "",
  methodDeterminingBaseIcms: "",
  valueBaseIcms: "",
  aliquotIcmsProduct: "",
  valueIcmsProduct: "",
  valueBaseRelatedCombatPoverty: "",
  percentageRelatedCombatPoverty: "",
  valueRelatedCombatPoverty: "",
  codeSituationTaxableCofins: "",
  codeSituationTaxablePis: "",
  csosnProduct: "",
  aliquotApplicableSimplesNacional: "",
  valueApplicableSimplesNacional: "",
  valueBaseIcmsST: "",
  // aliquotValueIcmsST: "",
  valueIcmsST: "",
  valueRelatedCombatPovertyFCP: "",
  percentageRelatedCombatPovertyFCP: "",
  valueRelatedCombatPovertyFCPWithheld: "",
  valueBaseIcmsSTWithheld: "",
  valueIcmsOwnSubstitute: "",
  valueIcmsStWithheld: "",
  valueBaseRelatedCombatPovertyWithhelPrevious: "",
  valueRelatedCombatPovertyWithhelST: "",
  percentageReductionBaseEffective: "",
  valueBaseEffective: "",

  valueTaxEffective: "",
  percentageReductionBaseIcms: "",
  valueCreditUsedSimplesNacional: "",
  valueBasePis: "",
  valuePis: "",
  amountPis: "",
  aliquotPisReais: "",
  valueBaseCofins: "",
  valueCofins: "",
  amountCofins: "",
  aliquotCofinsReais: "",
  cnpjProducerCommodity: "",
  codeSealcontrollerIPI: "",
  amountSealcontrollerIPI: "",
  totalInsuredValueProduct: "",
  otherIncidentalExpensesProduct: "",
};



async function execute(sales, enterprise) {

  try {
    let product = [];
    let numericItem = 1

    const totalDiscount = parseFloat(sales.value_descount_total || 0);
    const itemsWithDiscount = distributeDiscountAcrossItems(sales.itens_sales, totalDiscount);

    const totalProductsValue = sales.itens_sales.reduce((sum, item) => sum + parseFloat(item.value_subtotal_product), 0);
    const adjustmentTotal = parseFloat(sales.value_payment_adjustment_total || 0);

    itemsWithDiscount.forEach((item) => {
        productsNFe = { ...productsNFeInitial }
        
        productsNFe.aliquotApplicableSimplesNacional = 0;
        productsNFe.valueApplicableSimplesNacional = 0;
        productsNFe.aliquotIcmsProduct = item.aliquot_icms_product;
        productsNFe.aliquotPis = item.aliquota_pis ?? 0;
        productsNFe.aliquotCofins = item.aliquota_cofins ?? 0;
        productsNFe.aliquotPisReais = item.codeSituationTaxableCofins != "99" ? item.value_pis_product : 0;
        productsNFe.aliquotCofinsReais = item.codeSituationTaxableCofins != "99" ? item.value_cofins_product : 0;
        productsNFe.amountBusinessProduct = item.amount;
        productsNFe.amountCofins = validAmountPis(item.codeSituationTaxableCofins, item.amount); // item.codeSituationTaxableCofins != "99" ? item.amount : 0
        productsNFe.amountPis = validAmountCofins(item.codeSituationTaxablePis, item.amount); //item.codeSituationTaxablePis != "99" ? item.amount : 0
        productsNFe.amountSealcontrollerIPI = "";
        productsNFe.amountTaxProduct = item.amount;
        productsNFe.cfopProduct = item.product.cfop.code;
        productsNFe.cnpjProducerCommodity = "";
        productsNFe.codeCstProdut = (String(item.codeCstProdut) === '0' ? '00' : String(item.codeCstProdut));
        productsNFe.descriptionProduct = item.description.toString().substr(0, 120);
        productsNFe.codeManufacturerProduct = "";
        productsNFe.codeProduct = String(item.product_id);
        productsNFe.codeSealcontrollerIPI = "";
        productsNFe.codeSituationTaxableCofins = item.codeSituationTaxableCofins;
        productsNFe.codeSituationTaxablePis = item.codeSituationTaxablePis;
        productsNFe.csosnProduct = item.csosnProduct;
        productsNFe.cstProduct = item.product.cst.code;
        productsNFe.eanProduct = checkGetin(item.product.bar_code);
        productsNFe.extIpiProduct = "";
        productsNFe.indicatesWhetherProduct = 1;

        productsNFe.itemProduct = numericItem;
        productsNFe.methodDeterminingBaseIcms = String(item.methodDeterminingBaseIcms);
        productsNFe.ncmProduct = String(item.ncmProduct);
        productsNFe.nomenclatureValueCustomsProduct = "";
        productsNFe.percentageReductionBaseEffective = 0;
        productsNFe.percentageReductionBaseIcms = "";

        productsNFe.percentageRelatedCombatPoverty = enterprise.crt == 3 ? 2 : 0;
        productsNFe.valueRelatedCombatPoverty = enterprise.crt == 3
          ? caculationFunValuePoverty(productsNFe.percentageRelatedCombatPoverty, item.value_subtotal_product)
          : 0;
        productsNFe.percentageRelatedCombatPovertyFCP = 0;
        productsNFe.recipientProduct = "";
        productsNFe.relevantScaleIndicatorProduct = "";
        productsNFe.sourceMerchandise = item.sourceMerchandise;
        productsNFe.unitBusinessProduct = item.product.unit.sigla;
        productsNFe.unityTaxProduct = item.product.unit.sigla;
        productsNFe.valueBaseCofins = item.codeSituationTaxablePis != "99" ? item.value_base_cofins_product : 0;
        productsNFe.valueBaseEffective = "";
        productsNFe.valueBaseIcms = item.value_base_icms_product;
        productsNFe.valueBaseIcmsST = item.value_base_icms_st_product;
        productsNFe.valueBaseIcmsSTWithheld = "";
        productsNFe.valueBasePis = item.value_base_pis_product;
        productsNFe.valueBaseRelatedCombatPoverty = 0;
        productsNFe.valueDiscount = item.itemDiscount || 0;
        productsNFe.valueBaseRelatedCombatPovertyWithhelPrevious = item.valueBaseRelatedCombatPoverty;
        productsNFe.valueCofins = item.codeSituationTaxablePis != "99" ? item.value_cofins_product : 0;
        productsNFe.valueCostOfFreight = null;
        productsNFe.valueCreditUsedSimplesNacional = "";
        productsNFe.valueIcmsOwnSubstitute = "";
        productsNFe.valueIcmsProduct = item.value_icms_product;
        // productsNFe.aliquotValueIcmsST = 0
        productsNFe.valueIcmsStWithheld = "";
        productsNFe.valueInsurancePriceProduct = "";
        productsNFe.valueOfApproximateTax = item.valueOfApproximateTax;   //item.value_subtotal_product
        productsNFe.valuePis = item.value_pis_product;

        productsNFe.valueRelatedCombatPovertyFCP = 0;
        productsNFe.valueRelatedCombatPovertyFCPWithheld = 0;
        productsNFe.valueRelatedCombatPovertyWithhelST = 0;
        productsNFe.valueTaxEffective = "";
        productsNFe.valueTotalGrossProduct = item.value_subtotal_product;
        productsNFe.valueUnityBusinessProduct = item.value_sale;
        productsNFe.valueUnityTaxProduct = item.value_sale;
        productsNFe.totalInsuredValueProduct = 0;
        productsNFe.otherIncidentalExpensesProduct = 0;

        // Distribuir o ajuste (desconto/acréscimo) proporcionalmente nos produtos
        (() => {
          const itemAdjustment = distributeAdjustmentProportionally(
            adjustmentTotal,
            item.value_subtotal_product,
            totalProductsValue
          );

          if (itemAdjustment !== 0) {
            // Se é desconto (negativo), vai para vDesc (totalInsuredValueProduct)
            // Se é acréscimo (positivo), vai para vOutro (otherIncidentalExpensesProduct)
            if (itemAdjustment < 0) {
              productsNFe.totalInsuredValueProduct = Math.abs(itemAdjustment);
              productsNFe.otherIncidentalExpensesProduct = 0;
            } else {
              productsNFe.totalInsuredValueProduct = 0;
              productsNFe.otherIncidentalExpensesProduct = itemAdjustment;
            }

            // Ajustar base de cálculo de ICMS proporcionalmente
            // A base do ICMS deve considerar: vProd - vDesc + vOutro
            if (productsNFe.valueBaseIcms && parseFloat(productsNFe.valueBaseIcms) > 0) {
              const baseIcmsOriginal = parseFloat(item.value_base_icms_product);
              if (baseIcmsOriginal > 0) {
                const proportionAdjustment = itemAdjustment / parseFloat(item.value_subtotal_product);
                productsNFe.valueBaseIcms = baseIcmsOriginal * (1 + proportionAdjustment);

                if (productsNFe.aliquotIcmsProduct && parseFloat(productsNFe.aliquotIcmsProduct) > 0) {
                  productsNFe.valueIcmsProduct = productsNFe.valueBaseIcms * (parseFloat(productsNFe.aliquotIcmsProduct) / 100);
                }
              }
            }
          }
        })(),

        // IBS CBS - só incluir se houver classificação tributária e alíquota definida
        productsNFe.codeCest = item.codeCest
        if (item.classificationTribute && item.aliquot_ibs_cbs) {
          productsNFe.codeCstIbsCbs = item.codeCstIbsCbs;
          productsNFe.codeClassificationTribute = item.classificationTribute?.code;
          productsNFe.cbs = mounterCbsData(item);
          productsNFe.ibs = mounterIbsData(item);
          productsNFe.ibsCbsIndicators = getIbsCbsIndicators(item.classificationTribute, item.cstIbsCbs);
        }

      numericItem = numericItem + 1
      product.push(productsNFe);

    });

    return product;
  } catch (error) {
    return error;
  }
}

function validAmountPis(cstPis, amount) {
  switch (cstPis) {
    case "99":
      return 0;
    case "49":
      return 0;
    default:
      return amount;
  }
}

function validAmountCofins(cstCofins, amount) {
  switch (cstCofins) {
    case "99":
      return 0;
    case "49":
      return 0;
    default:
      return amount;
  }
}

function checkGetin(eanProduct) {
  if (eanProduct === null || eanProduct === '') {
    return 'SEM GTIN'
  }
  return eanProduct
}

function caculationFunValuePoverty(aliquot, valorProduct) {
  let valueCalcule = 0
  let taxPercentual = 0
  taxPercentual = aliquot / 100
  valueCalcule = parseFloat(valorProduct) * taxPercentual
  return valueCalcule
}

/**
 * Distribui o desconto total (inclui desconto fidelidade) proporcionalmente entre os itens
 * @param {Array} items - Array de itens da venda
 * @param {Number} totalDiscount - Valor total do desconto a ser distribuído
 * @returns {Array} - Array de itens com o desconto distribuído
 */
function distributeDiscountAcrossItems(items, totalDiscount) {
  if (!totalDiscount || totalDiscount <= 0 || !items || items.length === 0) {
    return items;
  }

  const totalProductsValue = items.reduce((sum, item) => {
    return sum + parseFloat(item.value_subtotal_product || 0);
  }, 0);

  if (totalProductsValue <= 0) {
    return items;
  }

  let distributedDiscount = 0;
  const itemsWithDiscount = items.map((item, index) => {
    const itemValue = parseFloat(item.value_subtotal_product || 0);

    let itemDiscount = 0;

    if (index === items.length - 1) {
      itemDiscount = parseFloat((totalDiscount - distributedDiscount).toFixed(2));
    } else {
      const proportion = itemValue / totalProductsValue;
      itemDiscount = parseFloat((totalDiscount * proportion).toFixed(2));
      distributedDiscount += itemDiscount;
    }

    return {
      ...item,
      itemDiscount: itemDiscount,
      value_descont_product: item.value_descont_product
        ? parseFloat(item.value_descont_product) + itemDiscount
        : itemDiscount
    };
  });

  return itemsWithDiscount;
}

/**
 * Distribui o ajuste de condição de pagamento (desconto/acréscimo) proporcionalmente
 */
function distributeAdjustmentProportionally(adjustmentTotal, itemValue, totalProductsValue) {
  if (adjustmentTotal === 0 || totalProductsValue === 0) {
    return 0;
  }
  const itemProportion = parseFloat(itemValue) / totalProductsValue;
  return adjustmentTotal * itemProportion;
}

module.exports = {
  execute,
};
